import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import MasterLogin from "@/pages/MasterLogin";
import MasterLayout from "@/layouts/MasterLayout";
import MasterDashboard from "@/pages/MasterDashboard";
import MasterTenants from "@/pages/MasterTenants";
import MasterTenantDetail from "@/pages/MasterTenantDetail";
import MasterTemplates from "@/pages/MasterTemplates";
import MasterAudit from "@/pages/MasterAudit";

import TenantLogin from "@/pages/TenantLogin";
import TenantLayout from "@/layouts/TenantLayout";
import TenantDashboard from "@/pages/TenantDashboard";
import TenantSettings from "@/pages/TenantSettings";
import TenantAudit from "@/pages/TenantAudit";
import TenantClients from "@/pages/TenantClients";
import TenantAgenda from "@/pages/TenantAgenda";
import TenantPetMedications from "@/pages/TenantPetMedications";
import TenantLoyalty from "@/pages/TenantLoyalty";
import TenantAutomations from "@/pages/TenantAutomations";
import TenantReferrals from "@/pages/TenantReferrals";
import TenantMessageTemplates from "@/pages/TenantMessageTemplates";
import TenantTiers from "@/pages/TenantTiers";
import TenantNPS from "@/pages/TenantNPS";
import TenantRecurrence from "@/pages/TenantRecurrence";
import TenantRiskManager from "@/pages/TenantRiskManager";
import TenantFunnel from "@/pages/TenantFunnel";
import TenantCampaignPresets from "@/pages/TenantCampaignPresets";
import PublicReferral from "@/pages/PublicReferral";
import PublicNPS from "@/pages/PublicNPS";
import PublicTemplatePreview from "@/pages/PublicTemplatePreview";
import TenantFinanceiro from "@/pages/TenantFinanceiro";
import TenantTeam from "@/pages/TenantTeam";
import PortalClientLogin from "@/pages/PortalClientLogin";
import PortalClientHome from "@/pages/PortalClientHome";
import PublicBooking from "@/pages/PublicBooking";
import EmpresaSite from "@/pages/EmpresaSite";
import PublicTeamGallery from "@/pages/PublicTeamGallery";
import OnboardingWizard from "@/pages/OnboardingWizard";
import { TooltipProvider } from "@/components/ui/tooltip";

function App() {
  return (
    <AuthProvider>
      <TooltipProvider delayDuration={150} skipDelayDuration={400}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />

          {/* PUBLIC referral landing */}
          <Route path="/r/:slug/:code" element={<PublicReferral />} />
          {/* PUBLIC NPS survey */}
          <Route path="/nps/:slug/:token" element={<PublicNPS />} />
          <Route path="/preview/:vertical" element={<PublicTemplatePreview />} />
          <Route path="/equipe/:slug" element={<PublicTeamGallery />} />

          {/* PORTAL DO CLIENTE — Sprint C */}
          <Route path="/portal/:slug/cliente/login" element={<PortalClientLogin />} />
          <Route path="/portal/:slug/cliente/home" element={<PortalClientHome />} />

          {/* AUTO-AGENDAMENTO PÚBLICO */}
          <Route path="/p/:slug/agendar" element={<PublicBooking />} />

          {/* SITE PÚBLICO DA EMPRESA (landing principal — quem você é?) */}
          <Route path="/empresa/:slug" element={<EmpresaSite />} />

          {/* MASTER */}
          <Route path="/master/login" element={<MasterLogin />} />
          <Route
            path="/master"
            element={
              <ProtectedRoute requireRole="master_admin">
                <MasterLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/master/dashboard" replace />} />
            <Route path="dashboard" element={<MasterDashboard />} />
            <Route path="tenants" element={<MasterTenants />} />
            <Route path="tenants/:id" element={<MasterTenantDetail />} />
            <Route path="templates" element={<MasterTemplates />} />
            <Route path="audit" element={<MasterAudit />} />
          </Route>

          {/* TENANT */}
          <Route path="/t/:slug/login" element={<TenantLogin />} />
          <Route
            path="/t/:slug"
            element={
              <ProtectedRoute requireRole="tenant">
                <TenantLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<TenantDashboard />} />
            <Route path="clientes" element={<TenantClients />} />
            <Route path="recorrencia" element={<TenantRecurrence />} />
            <Route path="gestor-de-risco" element={<TenantRiskManager />} />
            <Route path="funil" element={<TenantFunnel />} />
            <Route path="campanhas-prontas" element={<TenantCampaignPresets />} />
            <Route path="agenda" element={<TenantAgenda />} />
            <Route path="medicacoes" element={<TenantPetMedications />} />
            <Route path="fidelidade" element={<TenantLoyalty />} />
            <Route path="clube" element={<TenantTiers />} />
            <Route path="indicacao" element={<TenantReferrals />} />
            <Route path="mensagens" element={<TenantMessageTemplates />} />
            <Route path="equipe" element={<TenantTeam />} />
            <Route path="automacoes" element={<TenantAutomations />} />
            <Route path="nps" element={<TenantNPS />} />
            <Route path="satisfacao" element={<Navigate to="../nps" replace />} />
            <Route path="pesquisa" element={<Navigate to="../nps" replace />} />
            <Route path="financeiro" element={<TenantFinanceiro />} />
            <Route path="settings" element={<TenantSettings />} />
            <Route path="audit" element={<TenantAudit />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster richColors position="bottom-right" mobileOffset={{ bottom: "80px", right: "12px" }} />
      </BrowserRouter>
      </TooltipProvider>
    </AuthProvider>
  );
}

export default App;
